import { defineSlotRecipe } from '@chakra-ui/react';
import { selectAnatomy } from '@chakra-ui/react/anatomy';

export const selectRecipe = defineSlotRecipe({
  className: 'ac-select',
  slots: selectAnatomy.keys(),
  base: {
    root: {
      minWidth: '0px',
    },
    trigger: {
      position: 'relative',
      border: 'subtle',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'grey.light.2',
      borderRadius: 'xl',
      backgroundColor: 'white',
      height: '40px',
      verticalAlign: 'middle',
      padding: '0px 30px 0px 12px',
      // display: 'flex',
      // flexDirection: 'row',
      // justifyContent: 'space-between',
      // alignItems: 'center',
      fontSize: '15px',

      textAlign: 'left',

      fontFamily: 'acBase',

      minWidth: '160px',
      width: '100%',
      maxWidth: '100%',

      gap: '15px',

      transitionProperty: 'border, backgroundColor, background',
      transitionDuration: 'slow',
      transitionTimingFunction: 'linear',

      boxShadow: '10px 10px 15px 0px rgba(17, 17, 17, 0.02)',

      _open: {
        border: 'active',
      },

      _disabled: {
        cursor: 'disabled',
        backgroundColor: 'grey.light.0',
      },
    },
    valueText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      minWidth: '0px',

      display: 'block',
      maxWidth: '100%',

      wordBreak: 'break-all',
      whiteSpace: 'nowrap',
    },
    indicatorGroup: {
      position: 'absolute',
      top: '50%',
      right: '10px',
      transform: 'translateY(-50%)',
    },
    indicator: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',

      transitionDuration: 'fast',
      transitionProperty: 'backgroundColor',
      transitionTimingFunction: 'linear',

      '& > svg': {
        height: '1.2rem',
        width: '1.2rem',

        transitionDuration: 'fast',
        transitionProperty: 'transform',
        transitionTimingFunction: 'linear',
      },

      _open: {
        '& > svg': {
          transform: 'rotateZ(-180deg)',
        },
      },
    },
    itemIndicator: {
      display: 'none',
      alignItems: 'center',
      justifyContent: 'center',

      width: '15px',
      height: '15px',
      top: '50%',
      right: '8px',
      transform: 'translateY(-50%)',

      position: 'absolute',
      _checked: {
        display: 'flex',
      },
    },
    content: {
      backgroundColor: 'white',
      zIndex: 500,
      border: 'active',
      borderRadius: 'xl',
      overflow: 'hidden',
      overflowY: 'auto',
      maxHeight: 'var(--available-height)',
      fontFamily: 'acBase',
      _open: {
        animationStyle: 'menu-open',
        animationDuration: 'moderate',
      },
      _closed: {
        animationStyle: 'menu-close',
        animationDuration: 'moderate',
      },
    },
    item: {
      position: 'relative',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 30px 0 24px',
      fontSize: '15px',
      letterSpacing: '0.15px',
      color: 'black',
      backgroundColor: 'white',

      transitionProperty: 'border, backgroundColor, background, color',
      transitionDuration: 'fast',
      transitionTimingFunction: 'linear',

      userSelect: 'none',

      overflow: 'hidden',
      wordBreak: 'keep-all',
      textOverflow: 'ellipsis',
      whiteSpace: 'break-spaces',

      _odd: {
        backgroundColor: 'grey.light.0',
      },

      _hover: {
        backgroundColor: 'halton.green/10',
        // backgroundColor: 'grey.light.1',
      },

      _disabled: {
        color: 'grey.light.3',
        cursor: 'disabled',
      },
    },
    itemText: {
      maxWidth: '100%',
      overflow: 'hidden',
      wordBreak: 'keep-all',
      textOverflow: 'ellipsis',
      whiteSpace: 'break-spaces',
    },
  },
  variants: {
    sizing: {
      full: {
        root: {
          flexGrow: 1,
        },
      },
    },
    size: {
      md: {
        trigger: {
          height: '40px',
        },
      },
      lg: {
        trigger: {
          height: '48px',
        },
      },
    },
    variant: {
      outline: {
        trigger: {
          borderColor: 'grey.light.3',

          _hover: {
            backgroundColor: 'grey.blue.1',
            borderColor: 'grey.dark.2',
            // boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.1)',
            boxShadow: '10px 10px 15px 0px rgba(17, 17, 17, 0.02)',
          },

          _disabled: {
            borderColor: 'grey.light.2',
            color: 'grey.light.2',
            cursor: 'disabled',
          },
        },
      },
      inset: {
        trigger: {
          borderRadius: 'main',
          borderColor: 'grey.light.1',
          backgroundColor: 'grey.light.0',
          color: 'grey.dark.2',

          height: '48px',

          fontSize: '15px',
          fontWeight: 400,
          letterSpacing: '0.15px',

          _hover: {
            borderColor: 'grey.dark.2',
          },
          _open: {
            borderColor: 'grey.dark.2',
          },
        },
        indicator: {
          width: '28px',
          height: '28px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

          borderRadius: 'smaller',
          backgroundColor: 'white',
          border: '1px solid {colors.grey.light.1}',
          boxShadow: '10px 10px 15px 0px, rgba(17, 17, 17, 0.2)',

          transitionProperty: 'border, backgroundColor, background, color',
          transitionDuration: 'fast',
          transitionTimingFunction: 'linear',

          '& > svg': {
            width: '0.875rem',
            height: '0.875rem',
          },

          _open: {
            backgroundColor: 'grey.dark.2',
            color: 'white',
          },
        },
      },
      form: {
        trigger: {
          height: '44px',
          padding: '0px 30px 0px 12px',
          borderRadius: 'smaller',

          textOverflow: 'ellipsis',
          overflow: 'hidden',
        },
        content: {
          borderRadius: 'smaller',
        },
      },
      deviceForm: {
        trigger: {
          minWidth: '100px',
          height: '40px',
          borderRadius: 'smaller',

          textOverflow: 'ellipsis',
          overflow: 'hidden',
        },
        content: {
          borderRadius: 'smaller',
        },
      },
      subsection: {
        trigger: {
          height: '40px',
          borderRadius: 'smaller',
        },
        content: {
          borderRadius: 'smaller',
        },
      },
      assetPicker: {
        root: {
          width: '100%',
        },
        trigger: {
          height: '30px',
          width: '100%',
          padding: '10px 25px 10px 15px',
          borderRadius: 'small',
          borderColor: 'grey.light.1',
          fontSize: '13px',

          display: 'flex',
          alignItems: 'center',

          _hover: {
            borderColor: 'grey.dark.2',
          },
        },
        content: {
          borderRadius: 'small',
        },
        item: {
          fontSize: '13px',
          height: '30px',
          padding: '0 15px',
        },
      },
      cramped: {
        root: {
          minWidth: '120px',
        },
        trigger: {
          minWidth: '120px',
          fontSize: '12px',
          padding: '8px 20px 8px 8px',
        },
        content: {
          fontSize: '12px',
        },
        item: {
          fontSize: '12px',
          padding: '0 12px',
        },
      },
      compact: {
        root: {
          minWidth: '120px',
        },
        trigger: {
          height: '30px',
          padding: '0 0.5rem',
          borderRadius: 'small',
          minWidth: '120px',

          textOverflow: 'ellipsis',
          overflow: 'hidden',
          _placeholderShown: {
            color: 'grey.light.3',
          },
        },

        content: {
          borderRadius: 'small',
        },
        item: {
          height: '30px',
          padding: '0 0.5rem',
        },
        itemIndicator: {
          '& svg': {
            height: '15px',
          },
        },
      },
    },

    error: {
      none: {
        trigger: {
          borderColor: 'grey.light.2',
          _open: {
            border: 'active',
          },
        },
      },
      missing: {
        trigger: {
          borderColor: 'halton.red',

          _open: {
            borderColor: 'halton.red',
          },
        },
      },
    },
    itemSizing: {
      auto: {
        item: {
          height: 'auto',
          paddingTop: '8px',
          paddingBottom: '8px',
        },
        itemText: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          wordBreak: 'break-word',

          maxWidth: '100%',
        },
      },
    },
    textSizing: {
      small: {
        trigger: {
          fontSize: '12px',
        },
        content: {
          fontSize: '12px',
        },
        item: {
          fontSize: '12px',
        },
      },
    },
  },
});
